<template>
  <div>
    <div
      :class="['directory-item', { selected: isSelected }]"
      :style="{ paddingLeft: level * 20 + 10 + 'px' }"
      @click="handleClick"
    >
      <span
        v-if="hasChildren"
        class="expand-icon"
        style="margin-right: 4px; cursor: pointer;"
      >
        {{ isExpanded ? '▼' : '▶' }}
      </span>
      <span v-else style="width: 16px; display: inline-block;"></span>
      <span class="directory-icon">📁</span>
      <span class="directory-name">{{ directory.name }}</span>
    </div>

    <div v-if="hasChildren && isExpanded && directory.children">
      <DirectoryTreeNode
        v-for="child in directory.children"
        :key="child.id"
        :directory="child"
        :selected-id="selectedId"
        :level="level + 1"
        @select="(id) => $emit('select', id)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  directory: {
    type: Object,
    required: true
  },
  selectedId: {
    type: Number,
    default: null
  },
  level: {
    type: Number,
    default: 0
  }
})

const emit = defineEmits(['select'])

const isSelected = computed(() => props.selectedId === props.directory.id)
const hasChildren = computed(() => props.directory.children && props.directory.children.length > 0)

// 默认展开所有目录
const isExpanded = ref(true)

function handleClick() {
  // 如果有子目录，切换展开/折叠状态
  if (hasChildren.value) {
    isExpanded.value = !isExpanded.value
  }
  // 始终触发选择事件
  emit('select', props.directory.id)
}
</script>